import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-right',
  template: `<div class="center">
      <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.78385 2.06791L8.55208 7.04448C8.66846 7.16492 8.72625 7.32104 8.72625 7.47651C8.72625 7.63198 8.66846 7.78823 8.55208 7.90854L3.78385 12.8851C3.54552 13.1349 3.15 13.1431 2.90104 12.9038C2.65039 12.6662 2.64224 12.2689 2.88233 12.0207L7.25733 7.45304L2.88307 2.93224C2.64299 2.68484 2.65115 2.28692 2.90179 2.04916C3.15078 1.80984 3.54688 1.81817 3.78385 2.06791Z" fill="white"/>
      </svg>
    </div>
  `,
  styleUrls: ['./center.style.css'],
})
export class ChevronRightComponent {
}
